import { render, staticRenderFns } from "./list-order.vue?vue&type=template&id=47824afc&scoped=true&"
import script from "./list-order.vue?vue&type=script&lang=js&"
export * from "./list-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47824afc",
  null
  
)

export default component.exports